export default "__VITE_ASSET__Cowq$Ajy__"